import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from '../../../../../utils/utils';
import { useFormatMessage } from '../../../../../hooks';
import { createUser } from '../../../../../crud/users.crud';
import { IUser, IUserAddProps } from '../../../../../interfaces/user';

export const useCreateBuyer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingCreated, setLoading] = useState(false);
  const [successCreated, setSuccess] = useState(false);
  const [user, setUser] = useState<IUser | null>(null);
  const fm = useFormatMessage();
  const createdUser = (data: IUserAddProps) => {
    setLoading(true);
    createUser(data)
      .then(res => {
        setSuccess(true);
        setUser(res.data.data);
        enqueueSnackbar('Пользователь создан', { variant: 'success' });
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
          setUser(null);
        }, 100);
      });
  };

  return { createdUser, successCreated, loadingCreated, user };
};
